import { Component, OnInit,Inject } from '@angular/core';
import {BlogService} from "../../service/blog.service";
import {commonService} from "../../service/common.service";
import {ParamMap, Router, ActivatedRoute,Params } from '@angular/router';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.css'],
  providers:[BlogService]
})

export class BlogComponent implements OnInit {
  userData:any;

  option:any;
  blogId=0;
  BLOG={'title':'blog','desciprtion':'desciprtion'};
 
  constructor(private router: Router,private route: ActivatedRoute) {
    
    this.option={};

    const audioContext = new AudioContext();
/*const oscillatorNode = audioContext.createOscillator();

    oscillatorNode.connect(audioContext.destination);

    oscillatorNode.start();*/
    

    this.route.params.subscribe((params: Params) => {
      if(params['id']){    
      let id =atob( params['id']);
      this.blogId = parseInt(id);
      if(isNaN(this.blogId)){
        this.blogId=0;
      }
      this.option['blogId']=(this.blogId)?this.blogId:0;
      }
      
    });
    
   }

  ngOnInit() {
    
    
  }
  


}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/blog/blog.component.ts